import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const loginRoutes = [{
  path: '',
  name: 'login',
  component: () => import('../views/login/login.vue'),
},
{
  path: '/manage/password',
  name: 'password',
  component: () => import('../views/password/password.vue'),
}]

const manageRoutes = [{
  path: '/manage',
  name: '',
  redirect: {
    name: 'homepage'
  },
  component: () => import('../views/manage.vue'),
    children: [
      {
        path: '/manage/homepage',
        name: 'homepage',
        meta: {
          name: '首页',
          icon: 'el-icon-star-off',
        },
        component: () => import('../views/homepage/homepage.vue'),
      },
      {
        path: '/manage/message',
        name: 'message',
        meta: {
          name: '我的消息',
          icon: 'el-icon-star-off',
        },
        component: () => import('../views/message/messageList.vue'),
      },
      {
        path: '/manage/offlineManagement',
        name: 'offlineManagement',
        meta: {
          name: '线下赛管理',
          icon: 'el-icon-star-off',
        },
        redirect: {
          name: 'offline'
        },
        component: () => import('../views/offline/offlineManagement.vue'),
        children: [
          {
          path: '/manage/offline',
          name: 'offline',
          meta: {
            name: '线下赛',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/offline/offlineList.vue'),   
          },
          {
            path: '/manage/sessions',
            name: 'sessions',
            meta: {
              name: '场次管理',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/offline/sessionsList.vue')          
          }, 
          {
            path: '/manage/teams',
            name: 'teams',
            meta: {
              name: '团队管理',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/offline/teamsList.vue')          
          }, 
          {
            path: '/manage/events',
            name: 'events',
            meta: {
              name: '赛事项目',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/offline/eventsList.vue')          
          },
          {
            path: '/manage/groups',
            name: 'groups',
            meta: {
              name: '选手分组管理',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/offline/groupsList.vue')          
          },
          {
            path: '/manage/players',
            name: 'players',
            meta: {
              name: '选手列表',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/offline/playersList.vue')          
          }, 
          {
            path: '/manage/playerInfo',
            name: 'playerInfo',
            meta: {
              name: '选手信息及成绩管理',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/offline/playerInfoList.vue')          
          }
        ]
      },
      {
        path: '/manage/onlineManagement',
        name: 'onlineManagement',
        meta: {
          name: '线上赛管理',
          icon: 'el-icon-star-off',
        },
        redirect: {
          name: 'online'
        },
        component: () => import('../views/online/onlineManagement.vue'),
        children: [
          {
            path: '/manage/online',
            name: 'online',
            meta: {
              name: '线上赛',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/online/onlineList.vue'),   
          },
          {
            path: '/manage/netPlayers',
            name: 'netPlayers',
            meta: {
              name: '选手列表',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/online/playersList.vue')          
          }, 
          {
            path: '/manage/files',
            name: 'competeFiles',
            meta: {
              name: '参赛文件',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/online/competeFiles.vue')          
          }, 
          {
            path: '/manage/votes',
            name: 'playerVotes',
            meta: {
              name: '投票详情',
              icon: 'el-icon-star-off'
            },
            component: () => import('../views/online/playerVotes.vue')          
          }
        ]
      },
      {
        path: '/manage/competeProjectManagement',
        name: 'competeProjectManagement',
        meta: {
          name: '赛事项目管理',
          icon: 'el-icon-star-off',
        },
        redirect: {
          name: 'competeProject'
        },
        component: () => import('../views/competeProject/competeProjectManagement.vue'),
        children: [{
          path: '/manage/competeProject',
          name: 'competeProject',
          meta: {
            name: '赛事项目列表',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/competeProject/competeProjectList.vue')          
        }, {
          path: '/manage/competeCategory',
          name: 'competeCategory',
          meta: {
            name: '赛事类别管理',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/competeProject/competeCategoryList.vue')          
        }, {
          path: '/manage/competeEvents',
          name: 'competeEvents',
          meta: {
            name: '比赛项管理',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/competeProject/competeEventsList.vue')          
        }, {
          path: '/manage/competeGroups',
          name: 'competeGroups',
          meta: {
            name: '组别管理',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/competeProject/competeGroupsList.vue')          
        }, {
          path: '/manage/competeAgeGroup',
          name: 'competeAgeGroup',
          meta: {
            name: '组别管理',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/competeProject/competeAgeGroupList.vue')          
        }],
      },
      {
        path: '/manage/meetingRecordManagement',
        name: 'meetingRecordManagement',
        meta: {
          name: '赛会记录',
          icon: 'el-icon-star-off',
        },
        redirect: {
          name: 'meetingRecord'
        },
        component: () => import('../views/meetingRecord/meetingRecordManagement.vue'),
        children: [{
          path: '/manage/meetingRecord',
          name: 'meetingRecord',
          meta: {
            name: '赛会记录',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/meetingRecord/meetingRecordList.vue')          
        }, {
          path: '/manage/meetingRecordDetail',
          name: 'meetingRecordDetail',
          meta: {
            name: '赛会记录详情',
            icon: 'el-icon-star-off'
          },
          component: () => import('../views/meetingRecord/meetingRecordDetail.vue')          
        }],        
      },
      {
        path: '/manage/account',
        name: 'account',
        meta: {
          name: '账号管理',
          icon: 'el-icon-star-off',
        },
        component: () => import('../views/account/accountList.vue'),
      },
      {
        path: '/manage/rotation',
        name: 'rotation',
        meta: {
          name: '轮播图设置',
          icon: 'el-icon-star-off',
        },
        component: () => import('../views/rotation/rotationList.vue'),
      },
    ]
  }, 
]
// 写一个更改方法 可以再页面上更改router
export var menus = manageRoutes[0].children.slice(1)

// 解决同一路径被点击2次就报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...loginRoutes,
    ...manageRoutes
  ]
})